// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container,.container-fluid{max-width:1200px;display:flex;flex-direction:column}`, "",{"version":3,"sources":["webpack://./src/components/Container/style.scss"],"names":[],"mappings":"AAAA,4BAEE,gBAAA,CACA,YAAA,CACA,qBAAA","sourcesContent":[".container,\n.container-fluid {\n  max-width: 1200px;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
